import { ICustomerServive } from "../../../Frame/CustomerService/ICustomerService";
import { DynamicController } from "../../../Controls/Dynamic/DynamicController";

export class VetterStrategyCustomerService implements ICustomerServive {
    public measureListUpdateFields = (dynamicController: DynamicController) => {
        // LF#36 should be updated after an element of the measure list of "Terminverschiebung" was opened and closed.
        let fieldAngepassterTermin = dynamicController.getControl(36);

        if (fieldAngepassterTermin) {
            fieldAngepassterTermin.updateValueFromServer();
        }

        dynamicController.updateDataFromParentId();
    }
}